import { StyleSheet } from 'react-native';

import { ApplicationStyles, Colors } from '../../shared/themes';

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  centerText: {
    textAlign: 'center',
  },
  buttonText: {
    fontSize: 18,
    color: 'white',
    alignSelf: 'center',
  },
  button: {
    height: 36,
    backgroundColor: Colors.jhipsterBlue,
    borderColor: Colors.jhipsterBlue,
    borderWidth: 1,
    borderRadius: 8,
    marginBottom: 10,
    alignSelf: 'stretch',
    justifyContent: 'center',
  },
});
